module.exports = __webpack_public_path__ + "static/img/pie-chart.6bf2ec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/pie-chart.png
// module id = VbSR
// module chunks = 1